export const Pen = ({ size = 22, className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.66602 18.3333H7.33268L16.9577 8.70829C17.9702 7.69576 17.9702 6.05414 16.9577 5.04162C15.9452 4.0291 14.3035 4.0291 13.291 5.04162L3.66602 14.6666V18.3333"
        stroke="currentColor"
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.375 5.95801L16.0417 9.62467"
        stroke="currentColor"
        strokeOpacity="0.9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
